import React, { useEffect, useState } from "react";
import { DescriptionModal, ViewMore } from "../../../comman/action/ViewMore";
import NotFound from "../../../components/not-found/NotFound";
import MonetizationOnTwoToneIcon from "@mui/icons-material/MonetizationOnTwoTone";
import { IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RequestedModal from "./ViewRequestedModal";
import { cashConverter } from "../../../components/Form";
const RequestedFunds = ({ fundList, page, listing }) => {
  const [showModal, setShowModal] = useState(false);
  const [desValue, setDesValue] = useState("");
  const [viewModal, setViewModal] = useState(false);
  const [viewId, setViewId] = useState("");
  const [fundDetail, setFundDetail] = useState({
    name: "",
    amount: "",
    request: "",
    need: "",
    title: "",
    description: "",
    email: "",
    userName: "",
  });
  //-----------handle-pagination-----------
  const handleSeeMore = (value) => {
    setShowModal(true);
    setDesValue(value);
  };
  //-----------handle-view-details----------
  const handleViewDetails = (
    id,
    resource,
    users,
    request,
    need,
    name,
    amount,
    currentIncome,
    currentChallenges,
    financialSituation,
    goals,
    expectedBenefits,
    story
  ) => {
    setViewModal(true);
    setViewId(id);
    setFundDetail({
      name: name,
      amount: amount,
      request: request,
      title: resource?.title,
      need: need,
      description: resource?.description,
      email: users?.email,
      userName: users?.userName,
      currentIncome,
      currentChallenges,
      financialSituation,
      goals,
      expectedBenefits,
      story
    });
  };

  return (
    <>
      {/* <div className="FilterBox FilterArea justify-content-between">
                <div className="form-group search">
                    <input type="search"
                        className="form-control"
                        placeholder='Search'
                        value={search || ""}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
                <button className='btn_size' >Export as CSV</button>
            </div> */}
      <div className="content-table">
        <table>
          <thead>
            <tr>
              <th>S. No.</th>
              <th>Name</th>
              <th>User Name</th>
              <th>Email Address</th>
              <th>Resource Name</th>
              <th>Description</th>
              <th>Requested Amount</th>
              <th> Action </th>
            </tr>
          </thead>
          <tbody>
            {fundList.length > 0 ? (
              fundList.map(
                (
                  {
                    _id,
                    resourceName,
                    users,
                    name,
                    amount,
                    resource,
                    need,
                    request,
                    currentIncome,
                    currentChallenges,
                    financialSituation,
                    goals,
                    expectedBenefits,
                    story
                  },
                  index
                ) => {
                  return (
                    <React.Fragment key={index}>
                      <tr>
                        <td>{++index + (page - 1) * 10}</td>
                        <td>{users?.name || "N/A"}</td>
                        <td>{users?.userName || "N/A"}</td>
                        <td>{users?.email || "N/A"}</td>
                        <td>{resource?.title || "N/A"}</td>
                        <td>
                          <ViewMore
                            value={resource?.description}
                            handleSeeMore={handleSeeMore}
                          />
                        </td>
                        <td>{cashConverter(amount) || "N/A"}</td>
                        <td>
                          <IconButton
                            aria-label="update"
                            onClick={() =>
                              handleViewDetails(
                                _id,
                                resource,
                                users,
                                request,
                                need,
                                name,
                                amount,
                                currentIncome,
                                currentChallenges,
                                financialSituation,
                                goals,
                                expectedBenefits,
                                story
                              )
                            }
                          >
                            <VisibilityIcon
                              sx={{ color: "#C86337", fontSize: 26 }}
                            />
                          </IconButton>
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                }
              )
            ) : (
              <NotFound
                cols={10}
                msg="No Requested Funds Found!"
                icon={<MonetizationOnTwoToneIcon style={{ fontSize: 48 }} />}
              />
            )}
          </tbody>
        </table>
      </div>
      {/* -------see-more-modal--------- */}
      <DescriptionModal
        show={showModal}
        close={() => setShowModal(false)}
        value={desValue}
      />
      {/* -------view-details-modal--------- */}
      <RequestedModal
        show={viewModal}
        close={() => setViewModal(false)}
        id={viewId}
        fundDetail={fundDetail}
        listing={listing}
      />
    </>
  );
};

export default RequestedFunds;
